import { render } from "./StudioMain.vue?vue&type=template&id=00f202cb&scoped=true"
import script from "./StudioMain.vue?vue&type=script&lang=js"
export * from "./StudioMain.vue?vue&type=script&lang=js"

import "./StudioMain.vue?vue&type=style&index=0&id=00f202cb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f202cb"]])

export default __exports__